import { ICommunityGrant } from 'src/commons';
import { CommunityGrantActionTypes, CommunityGrantActions } from './community-grant.actions';

export interface State {
    error: string | null;
    pending: boolean;
    stateData: ICommunityGrant | null;
}

export const initialState: State = {
    error: null,
    pending: false,
    stateData: null
};

export function reducer(state = initialState, action: CommunityGrantActions): State {
    switch (action.type) {

        case CommunityGrantActionTypes.LoadCommunityGrantState: {
            return {
                ...state,
                error: null,
                pending: true
            };
        }

        case CommunityGrantActionTypes.LoadCommunityGrantStateSuccess: {
            return {
                error: null,
                pending: false,
                stateData: action.payload
            };
        }

        case CommunityGrantActionTypes.LoadCommunityGrantStateFail: {
            return {
                ...state,
                error: action.payload,
                pending: false
            };
        }

        case CommunityGrantActionTypes.CommunityGrantScreenErrorReset: {
            return {
                ...state,
                error: null,
                pending: false
            };
        } 
        
        case CommunityGrantActionTypes.LoadInitialState: {
            return initialState;
        }

        default: {
            return state;
        }
    }
}

export const getError = (state: State) => state.error;
export const getPending = (state: State) => state.pending;
export const getStateData = (state: State) => state.stateData;